import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { dynamicClassName } from 'styles/helper'

import styles from './Title.module.less'

type TitleProps = {
  title: string
  subTitle?: string
  size?: `large` | `medium` | `small`
  marginLeft?: boolean
}

export default function Title({ title, subTitle, size, marginLeft }: TitleProps): ReactElement {
  const { t } = useTranslation()
  return (
    <div className={styles.Title_Header}>
      <div
        className={dynamicClassName({
          [styles.Title_Title]: true,
          [styles.Title_Title__medium]: size === `medium`,
          [styles.Title_Title__small]: size === `small`,
          [styles.Title_Title__marginLeft]: marginLeft === true,
        })}
      >
        {t(`${title}`)}
      </div>
      {subTitle && (
        <div
          className={dynamicClassName({
            [styles.Title_Title]: true,
            [styles.Title_Title__small]: true,
          })}
        >
          {t(`${subTitle}`)}
        </div>
      )}
    </div>
  )
}
